import * as types from '@/constants/mutationTypes'

const state = {
  projectsList: [],
  fullProjectsList: [],
  projectUserId: null,
  tags: [],
  typeServiceList: [],
  removedProjectSteps: null
}
const getters = {
  projectsList: state => state.projectsList,
  fullProjectsList: state => state.fullProjectsList,
  tags: state => state.tags,
  typeServiceList: state => state.typeServiceList,
  projectUserId: state => state.projectUserId,
  removedStepsOfProject: state => state.removedProjectSteps
}
const actions = {
  setProjectsList ({commit}, data) {
    commit(types.SET_PROJECTS_LIST, {data})
  },
  setTags ({commit}, data) {
    commit(types.SET_TAGS, {data})
  },
  setTypeServiceList ({commit}, data) {
    commit(types.SET_TYPE_SERVICE_LIST, {data})
  },
  setFullProjectsList ({commit}, data) {
    commit(types.SET_FULL_PROJECTS_LIST, {data})
  },
  setProjectUserId ({commit}, data) {
    commit(types.SET_PROJECT_USER_ID, {data})
  },
  setRemovedProjectSteps ({commit}, data) {
    commit(types.SET_REMOVED_PROJECT_STEPS, {data})
  },
}
const mutations = {
  [types.SET_PROJECTS_LIST] (state, {data}) {
    state.projectsList = data
  },
  [types.SET_TAGS] (state, {data}) {
    state.tags = data
  },
  [types.SET_TYPE_SERVICE_LIST] (state, {data}) {
    state.typeServiceList = data
  },
  [types.SET_FULL_PROJECTS_LIST] (state, {data}) {
    state.fullProjectsList = data
  },
  [types.SET_PROJECT_USER_ID] (state, {data}) {
    state.projectUserId = data
  },
  [types.SET_REMOVED_PROJECT_STEPS] (state, {data}) {
    state.removedProjectSteps = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/Projects/modules/store.js